module.exports = __webpack_public_path__ + "media/summer_2025_sweepstakes/facebook-035fd470.svg";